<template>
    <div>
        <!-- 头图部分 -->
        <div class="banner">
            <div class="main">
                <div class="swiper-container banner-swiper">
                    <div class="swiper-wrapper" v-if="bannerList.length">
                        <div class="swiper-slide" v-for="(item, index) in bannerList" :key="index">
                            <img :src="item.coverPicture" />
                        </div>
                    </div>
                    <div class="swiper-pagination"></div>
                    <!-- <div class="swiper-button-prev"></div>
                    <div class="swiper-button-next"></div> -->
                </div>
            </div>
        </div>
        <!-- 新闻部分 -->
        <div class="news">
            <div class="main">
                <div class="swiper-container news-swiper">
                    <div class="swiper-wrapper" v-if="newsListSwiper.length">
                        <div class="swiper-slide" v-for="(item, index) in newsListSwiper" :key="index">
                            <img :src="item.coverPicture" style="width: 100%" />
                            <p class="swiper-title">
                                {{ item.topic }}
                            </p>
                        </div>
                    </div>
                    <div class="swiper-pagination"></div>
                </div>
                <div class="right">
                    <div class="block" style="margin: 0; background: url('../../static/img/zfxxgka.png') no-repeat;  background-color: #31689b;" >
                        <h4 class="title">通知公告</h4>
                        <a class="more" @click="handleMoreNotice">更多>></a>
                    </div>
                    <div class="list">
                        <ul v-if="noticeList.length">
                            <li v-for="(item, index) in noticeList" :key="index" class="item" @click="handleDetailNotice(item)">
                                <a class="title">{{ item.topic }}</a>
                                <span class="date" v-if="item.publishTime"> {{ item.publishTime.substring(0,10) }}</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <!-- 政策 & 动态 -->
        <div class="news">
            <div class="main">
                <div class="left">
                    <div class="block" style="margin: 0; background: url('../../static/img/image4.png') no-repeat;  background-color: #31689b;">
                        <h4 class="title">政策法规</h4>
                        <a class="more" @click="handleMorePolicy">更多>></a>
                    </div>
                    <div class="list">
                        <ul v-if="policyList.length">
                            <li v-for="(item, index) in policyList" :key="index" class="item" @click="handleDetailPolicy(item)">
                                <a class="title">{{ item.topic }}</a>
                                <span class="date" v-if="item.publishTime"> {{ item.publishTime.substring(0,10) }}</span>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="right">
                    <div class="block" style="margin: 0; background: url('../../static/img/zffwptb.png') no-repeat;  background-color: #31689b;">
                        <h4 class="title">协会动态</h4>
                        <a class="more" @click="handleMore('10')">更多>></a>
                    </div>
                    <div class="list">
                        <ul v-if="dynamicList.length">
                            <li v-for="(item, index) in dynamicList" :key="index" class="item" @click="detailNews(item)">
                                <a class="title">{{ item.topic }}</a>
                                <span class="date" v-if="item.publishTime"> {{ item.publishTime.substring(0,10) }}</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <!-- 专栏 & 动态 -->
        <div class="news">
            <div class="main">
                <div class="left">
                    <div class="block" style="margin: 0; background: url('../../static/img/zffwptb.png') no-repeat;  background-color: #31689b;">
                        <h4 class="title">双创专栏</h4>
                        <a class="more" @click="handleMore('12')">更多>></a>
                    </div>
                    <div class="list">
                        <ul v-if="specialList.length">
                            <li v-for="(item, index) in specialList" :key="index" class="item" @click="detailNews(item)">
                                <a class="title">{{ item.topic }}</a>
                                <span class="date" v-if="item.publishTime"> {{ item.publishTime.substring(0,10) }}</span>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="right">
                    <div class="block" style="margin: 0; background: url('../../static/img/zffwptb.png') no-repeat;  background-color: #31689b;">
                        <h4 class="title">科技动态</h4>
                        <a class="more" @click="handleMore('13')">更多>></a>
                    </div>
                    <div class="list">
                        <ul v-if="scienceList.length">
                            <li v-for="(item, index) in scienceList" :key="index" class="item" @click="detailNews(item)">
                                <a class="title">{{ item.topic }}</a>
                                <span class="date" v-if="item.publishTime"> {{ item.publishTime.substring(0,10) }}</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <!-- 贡献奖和综合服务平台 -->
        <div class="news">
            <div class="main" style="display: block;height: 0.47rem; "> 
                <div class="block" style="margin: 0; background: url('../../static/img/zfxxgka.png') no-repeat;  background-color: #31689b;">
                    <h4 class="title" style="flex: none;">服务平台</h4>
                    <!-- <p style="color: #fff;font-size: 16px;margin-top: 7px;
                    margin-left: 20px;">支撑科技创新 服务科研人员</p> -->
                </div>
            </div>
            <div class="main" style="margin-top: 12px;">
                <div class="left" style="border: 1px solid #ccc;">
                    <div class="block" style="margin: 0;padding: 0 0.24rem;background: rgba(49,105,155,.1);">
                        <h4 class="title" style="text-align: center;padding-left: 0;color: #31689b;">科技创业贡献奖</h4>
                    </div>
                    <div class="list" style="padding: 0.14rem 0.2rem;">
                        <ul v-if="awradList.length">
                            <li v-for="(item, index) in awradList" :key="index" class="item" @click="detailAward(item)" style="border: 0;line-height: 0.34rem;">
                                <a class="title">{{ item.topic }}</a>
                                <span class="date" v-if="item.publishTime"> {{ item.publishTime.substring(0,10) }}</span>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="right" style="border: 1px solid #ccc;">
                    <div class="block" style="margin: 0;padding: 0 0.24rem;background: rgba(49,105,155,.1);">
                        <h4 class="title" style="text-align: center;padding-left: 0;color: #31689b;">综合服务平台</h4>
                    </div>
                    <div class="dict-list">
                        <ul style="display: flex;border-bottom: 1px solid #e9e7e7;line-height: 0.44rem;
                        font-size: 0.15rem;cursor: pointer;" v-if="typeList.length">
                            <li class="item" v-for="(itemType, index) in typeList" :key="index" @click="handleType(itemType)" style="flex: 1;text-align: center;">
                                <span :class="[serviceParams.dictId == itemType.id ? 'active' : '']" style="display: inline-block;padding: 0 0.08rem;line-height: 0.4rem;">{{ itemType.dictPro }}</span>
                            </li>
                        </ul>
                    </div>
                    <div class="list" style="padding: 0.1rem 0.2rem;">
                        <ul v-if="serviceList.length">
                            <li v-for="(item, index) in serviceList" :key="index" class="item" @click="detailService(item)" style="border: 0;line-height: 0.34rem;">
                                <a class="title">{{ item.topic }}</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <!-- 快捷方式 -->
        <div class="short-cut">
            <div class="main">
                <ul>
                    <li @click="toMail">
                        <img src="../../static/img/xinxiang.png" alt="" />
                        <span>协会信箱</span>
                    </li>
                    <!-- <li>
                        <img src="../../static/img/wenda.png" alt="" />
                        <span>公众问答</span>
                    </li> -->
                    <li @click="toVip">
                        <img src="../../static/img/huiyuan.png" alt="" />
                        <span>会员申请</span>
                    </li>
                    <li @click="toLink">
                        <img src="../../static/img/9.png" alt="" />
                        <span>联系我们</span>
                    </li>
                </ul>
            </div>
        </div>

        <!-- 合作伙伴 -->
        <div class="partner">
            <div class="main">
                <div class="link-con" style="position: relative">
                    <div class="swiper-container swiper2">
                        <ul v-if="partnerList.length" class="clearfix swiper-wrapper">
                            <li class="swiper-slide fl" v-for="(item, index) in partnerList" :key="index">
                                <img :src="item.picture" alt="" class="partner-img" />
                            </li>
                        </ul>
                    </div>
                    <div class="swiper-button-prev swiper-button-mine"></div>
                    <div class="swiper-button-next swiper-button-mine"></div>
                </div>
            </div>
        </div>
        <!-- 友情链接 -->
        <div class="link">
            <div class="main">
                <div class="block">
                    <i class="line"></i>
                    <h4 class="title" style="color: #333;padding-left: 18px;">友情链接</h4>
                </div>
                <ul v-if="linkList.length">
                    <li class="item" v-for="(item, index) in linkList" :key="index">
                        <a @click="detailLink(item)">
                            <img :src="item.picture" alt="" />
                        </a>
                    </li>
                </ul>
            </div>
        </div>
        <!-- 广告飘窗 -->
        <div v-for="(item,index) in popupList" :key="index" style="width: 280px;">
            <div v-if="index == 0 && item.show" style="position: fixed;left: '0';top: 50px; width: 280px">
                <div style="
                cursor: pointer;
                text-align: right;
                font-size: 12px;
                color: #999999;
              " @click="handleClose(index)">
                    关闭
                </div>
                <div style="background: #fff;padding: 14px;border-radius: 3px;box-shadow: 0 2px 4px rgb(0 0 0 / 12%), 0 0 6px rgb(0 0 0 / 4%);" class="box">
                    <h4 style="text-align: center;font-size: 15px;margin-bottom: 10px;">{{item.title}}</h4>
                    <div v-html="item.content"></div>
                </div>
            </div>

            <div v-if="index == 1 && item.show" style="position: fixed;right: 0;top: 40px; width: 280px">
                <div style="
                cursor: pointer;
                text-align: right;
                font-size: 12px;
                color: #999999;
              " @click="handleClose(index)">
                    关闭
                </div>
                <div style="background: #fff;padding: 14px;border-radius: 3px;box-shadow: 0 2px 4px rgb(0 0 0 / 12%), 0 0 6px rgb(0 0 0 / 4%);" class="box">
                    <h4 style="text-align: center;font-size: 15px;margin-bottom: 10px;">{{item.title}}</h4>
                    <div v-html="item.content"></div>
                </div>
            </div>

            <div v-if="index == 2 && item.show" style="position: fixed;left: '0';top: 370px; width: 280px">
                <div style="
                cursor: pointer;
                text-align: right;
                font-size: 12px;
                color: #999999;
              " @click="handleClose(index)">
                    关闭
                </div>
                <div style="background: #fff;padding: 14px;border-radius: 3px;box-shadow: 0 2px 4px rgb(0 0 0 / 12%), 0 0 6px rgb(0 0 0 / 4%);" class="box">
                    <h4 style="text-align: center;font-size: 15px;margin-bottom: 10px;">{{item.title}}</h4>
                    <div v-html="item.content"></div>
                </div>
            </div>

            <div v-if="index == 3 && item.show" style="position: fixed;right: 0;top: 360px; width: 280px">
                <div style="
                cursor: pointer;
                text-align: right;
                font-size: 12px;
                color: #999999;
              " @click="handleClose(index)">
                    关闭
                </div>
                <div style="background: #fff;padding: 14px;border-radius: 3px;box-shadow: 0 2px 4px rgb(0 0 0 / 12%), 0 0 6px rgb(0 0 0 / 4%);" class="box">
                    <h4 style="text-align: center;font-size: 15px;margin-bottom: 10px;">{{item.title}}</h4>
                    <div v-html="item.content"></div>
                </div>
            </div>

            <div v-if="index == 4 && item.show" style="position: fixed;left: '0';bottom: 10px; width: 280px">
                <div style="
                cursor: pointer;
                text-align: right;
                font-size: 12px;
                color: #999999;
              " @click="handleClose(index)">
                    关闭
                </div>
                <div style="background: #fff;padding: 14px;border-radius: 3px;box-shadow: 0 2px 4px rgb(0 0 0 / 12%), 0 0 6px rgb(0 0 0 / 4%);" class="box">
                    <h4 style="text-align: center;font-size: 15px;margin-bottom: 10px;">{{item.title}}</h4>
                    <div v-html="item.content"></div>
                </div>
            </div>

            <div v-if="index == 5 && item.show" style="position: fixed;right: 0;bottom: 10px; width: 280px">
                <div style="
                cursor: pointer;
                text-align: right;
                font-size: 12px;
                color: #999999;
              " @click="handleClose(index)">
                    关闭
                </div>
                <div style="background: #fff;padding: 14px;border-radius: 3px;box-shadow: 0 2px 4px rgb(0 0 0 / 12%), 0 0 6px rgb(0 0 0 / 4%);" class="box">
                    <h4 style="text-align: center;font-size: 15px;margin-bottom: 10px;">{{item.title}}</h4>
                    <div v-html="item.content"></div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import Popup from "../components/Popup.vue"
    import { getDict } from "../api/dict";
    import { getBannerQuery } from "../api/banner";
    import { getNoticeQuery } from "../api/notice.js"
    import { getPolicyQuery } from "../api/policy.js"
    import { getNewsList } from "../api/news";
    import { getPartnerQuery } from "../api/partner.js"
    import { getLinksList } from "../api/link";
    import { getIntegratedServicesQuery } from "../api/mixService.js"
    import { getAwardQuery } from "../api/award.js";
    import Swiper from "swiper";
    import "swiper/dist/css/swiper.css";
    import { getPopupQuery } from "../api/popup.js"
    export default {
        components: {
            Popup
        },
        data() {
            return {
                // 头图
                bannerList: [],
                bannerEmpty: false,
                bannerLoading: true,
                // 新闻
                newsListSwiper: [],
                //通知公告
                noticeList: [],
                //政策法规
                policyList: [],
                //协会动态
                dynamicList: [],
                //双创专栏
                specialList: [],
                //科技动态
                scienceList: [],
                //合作伙伴
                partnerList: [],
                //友情链接
                linkList: [],
                //综合服务平台
                typeList: [],
                serviceParams: {
                    dictId: "",
                    page: 1,
                    pageSize: 7
                },
                serviceList: [],
                //贡献奖
                awradList: [],

                popupList: []
            };
        },
        created() {
            this.getBannerQuery();
            this.getNewsListBanner();
            this.getNoticeQuery();
            this.getPolicyQuery();
            this.getNewsDynamicList();
            this.getNewsSpecialList();
            this.getNewsScienceList();
            this.getPartnerQuery();
            this.getLinksList();
            this.getDict();
            this.getAwardQuery();
            this.getPopupQuery();
        },
        methods: {
            handleClose(index) {
                this.popupList.forEach((ele, i) => {
                    if (i == index) {
                        this.$set(ele, 'show', false)
                    }
                });
            },

            //获取弹窗
            getPopupQuery() {
                getPopupQuery().then(res => {
                    let popupList = res.data;
                    let arr = []
                    popupList.forEach((ele,i) => {
                        this.$set(ele, 'show', true)
                        if(ele.isEnabled) {
                            arr.push(ele)    
                        }
                    });
                    this.popupList = arr;
                })
            },
            toMail() {
                window.open("https://mail.163.com/")
            },

            toVip() {
                this.$router.push({
                    path: "/index/VipList"
                })
            },

            toLink() {
                this.$router.push({
                    path: "/index/LinkList"
                })
            },

            getAwardQuery() {
                let params = {
                    page: 1,
                    pageSize: 8
                }
                getAwardQuery(params).then(res => {
                    if (res.code == 200) {
                        this.awradList = res.data.records;
                    }
                })
            },

            detailAward(item) {
                let routeUrl = this.$router.resolve({
                    path: "/index/AwardDetail",
                    query: {
                        id: item.id
                    },
                });
                window.open(routeUrl.href, "_blank");
            },

            getDict() {
                getDict("6").then(res => {
                    if (res.code == 200) {
                        this.typeList = res.data;
                        this.serviceParams.dictId = this.typeList[0].id;
                        this.getIntegratedServicesQuery();
                    }
                })
            },

            handleType(item) {
                this.serviceParams.dictId = item.id
                this.getIntegratedServicesQuery();
            },

            getIntegratedServicesQuery() {
                getIntegratedServicesQuery(this.serviceParams).then(res => {
                    if (res.code == 200) {
                        this.serviceList = res.data.records;
                    }
                })
            },

            detailService(item) {
                if (item.jumpUrl) {
                    window.open(item.jumpUrl)
                    return;
                }
                if (item.info) {
                    let routeUrl = this.$router.resolve({
                        path: "/index/ServiceDetail",
                        query: {
                            id: item.id
                        },
                    });
                    window.open(routeUrl.href, "_blank");
                }
            },

            initSwiperTrain() {
                let that = this;
                setTimeout(() => {
                    let mySwiper = new Swiper(".swiper2", {
                        slidesPerGroup: 1,
                        slidesPerView: 3,
                        spaceBetween: 10,
                        autoplay: 3000,
                        speed: 300,
                        loop: true,
                        autoplayDisableOnInteraction: false,
                        effect: "slide",
                        observer: true,
                        observerParents: true,
                        observeSlideChildren: true,
                        prevButton: ".swiper-button-prev",
                        nextButton: ".swiper-button-next",
                        centeredSlides: true,
                        hideOnClick: true,
                        loopAdditionalSlides: 2,
                        onTap: function(mySwiper, event) {
                            let i = mySwiper.activeIndex;
                            if (i > that.partnerList.length) {
                                i = 1;
                            }
                            let item = that.partnerList[i - 1];
                            if (item.jumpUrl) {
                                window.open(item.jumpUrl);
                            }
                            // if (!item.jumpUrl && item.content) {
                            //     let routeUrl = that.$router.resolve({
                            //         name: "BannerDetail",
                            //         query: {
                            //             id: item.id,
                            //         },
                            //     });
                            //     window.open(routeUrl.href, "_blank");
                            // }
                        },
                    });
                }, 500);
            },

            //通知公告
            getNoticeQuery() {
                let params = {
                    page: 1,
                    pageSize: 7
                }
                getNoticeQuery(params).then(res => {
                    if (res.code == 200) {
                        this.noticeList = res.data.records;
                    }
                })
            },

            handleMoreNotice() {
                let routeUrl = this.$router.resolve({
                    path: "/index/NoticeList"
                });
                window.open(routeUrl.href, "_blank");
            },

            handleDetailNotice(item) {
                let routeUrl = this.$router.resolve({
                    path: "/index/NoticeDetail",
                    query: {
                        id: item.id
                    },
                });
                window.open(routeUrl.href, "_blank");
            },

            //政策法规
            getPolicyQuery() {
                let params = {
                    page: 1,
                    pageSize: 7
                }
                getPolicyQuery(params).then(res => {
                    if (res.code == 200) {
                        this.policyList = res.data.records;
                    }
                })
            },

            handleMorePolicy() {
                let routeUrl = this.$router.resolve({
                    path: "/index/PolicyList"
                });
                window.open(routeUrl.href, "_blank");
            },

            handleDetailPolicy(item) {
                let routeUrl = this.$router.resolve({
                    path: "/index/PolicyDetail",
                    query: {
                        id: item.id
                    },
                });
                window.open(routeUrl.href, "_blank");
            },


            //协会动态
            getNewsDynamicList() {
                let params = {
                    page: 1,
                    pageSize: 7,
                    dictId: 10
                }
                getNewsList(params).then(res => {
                    if (res.code == 200) {
                        this.dynamicList = res.data.records;
                    }
                })
            },

            //双创专栏
            getNewsSpecialList() {
                let params = {
                    page: 1,
                    pageSize: 7,
                    dictId: 12
                }
                getNewsList(params).then(res => {
                    if (res.code == 200) {
                        this.specialList = res.data.records;
                    }
                })
            },

            //科技动态
            getNewsScienceList() {
                let params = {
                    page: 1,
                    pageSize: 7,
                    dictId: 13
                }
                getNewsList(params).then(res => {
                    if (res.code == 200) {
                        this.scienceList = res.data.records;
                    }
                })
            },

            //合作伙伴
            getPartnerQuery() {
                getPartnerQuery().then(res => {
                    if (res.code == 200) {
                        this.partnerList = res.data;
                        this.initSwiperTrain();
                    }
                })
            },

            // 头图
            getBannerQuery() {
                getBannerQuery("1").then((res) => {
                    if (res.code == 200) {
                        this.bannerList = res.data;
                        this.initSwiperBanner();
                    }
                });
            },

            initSwiperBanner() {
                let that = this;
                setTimeout(() => {
                    let mySwiper = new Swiper(".banner-swiper", {
                        autoplay: 0,
                        speed: 1000,
                        loop: true,
                        paginationClickable: true,
                        autoplayDisableOnInteraction: false,
                        effect: "slide",
                        observer: true,
                        observerParents: true,
                        observeSlideChildren: true,
                        preventClicks: false,
                        pagination: ".banner-swiper>.swiper-pagination",
                        navigation: {
                            nextEl: ".swiper-button-next",
                            prevEl: ".swiper-button-prev",
                        },
                        hideOnClick: true,
                        onTap: function(mySwiper, event) {
                            let i = mySwiper.activeIndex;
                            if (i > that.bannerList.length) {
                                i = 1;
                            }
                            let item = that.bannerList[i - 1];
                            if (item.jumpUrl) {
                                window.open(item.jumpUrl);
                            }
                            // if (!item.jumpUrl && item.content) {
                            //     let routeUrl = that.$router.resolve({
                            //         name: "BannerDetail",
                            //         query: {
                            //             id: item.id,
                            //         },
                            //     });
                            //     window.open(routeUrl.href, "_blank");
                            // }
                        },
                    });
                }, 500);
            },

            // 动态信息
            handleMore(dictId) {
                let routeUrl = this.$router.resolve({
                    path: "/index/InfoList",
                    query: {
                        dictId
                    },
                });
                window.open(routeUrl.href, "_blank");
            },

            detailNews(item) {
                let routeUrl = this.$router.resolve({
                    path: "/index/InfoDetail",
                    query: {
                        dictId: item.dictId,
                        id: item.id,
                    },
                });
                window.open(routeUrl.href, "_blank");
            },

            //新闻轮播
            getNewsListBanner() {
                getBannerQuery("2").then((res) => {
                    if (res.code == 200) {
                        this.newsListSwiper = res.data;
                        this.initSwiperNews();
                    }
                });
            },

            initSwiperNews() {
                let that = this;
                setTimeout(() => {
                    let mySwiper = new Swiper(".news-swiper", {
                        autoplay: 0,
                        speed: 1000,
                        loop: true,
                        paginationClickable: true,
                        autoplayDisableOnInteraction: false,
                        effect: "slide",
                        observer: true,
                        observerParents: true,
                        observeSlideChildren: true,
                        preventClicks: false,
                        pagination: ".news-swiper>.swiper-pagination",
                        navigation: {
                            nextEl: ".swiper-button-next",
                            prevEl: ".swiper-button-prev",
                        },
                        hideOnClick: true,
                        onTap: function(mySwiper, event) {
                            let i = mySwiper.activeIndex;
                            if (i > that.bannerList.length) {
                                i = 1;
                            }
                            let item = that.bannerList[i - 1];
                            if (item.jumpUrl) {
                                window.open(item.jumpUrl);
                            }
                        },
                    });
                }, 1000);
            },

            //友情链接
            getLinksList() {
                let params = {
                    title: "",
                };
                getLinksList(params).then((res) => {
                    if (res.code == 200) {
                        this.linkList = res.data;
                    }
                });
            },

            detailLink(item) {
                window.open(item.jumpUrl);
            },
        },
    };
</script>

<style>
    @import "../assets/style.css";
    @import "../assets/style-mob.css";
</style>

<style scoped>
    .swiper2 {
        width: 12rem;
        padding-top: 0.4rem;
        padding-bottom: 0.2rem;
        overflow: hidden;
        margin: 0 auto;
    }

    .partner-img {
        width: 3.10rem;
        height: 0.58rem;
        display: block;
        margin: 0 auto;
    }

    .active {
        color: #e6000d;
        border-bottom: 2px solid #e6000d;
    }
</style>


<style>
    .swiper-pagination-bullet-active {
        background: #306baf !important;
        opacity: 1 !important;
    }

    .swiper-button-prev {
        width: 19px !important;
        height: 19px !important;
        top: 78px !important;
        background: url(../../static/img/imgbtnl.png) !important;
    }

    .swiper-button-next {
        width: 19px !important;
        height: 19px !important;
        top: 78px !important;
        background: url(../../static/img/imgbtnr.png) !important;
    }
</style>


// WEBPACK FOOTER //
// src/views/HomePage.vue